
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext'
import React, { useEffect, useRef, useState } from 'react'
import { FilterMatchMode } from "primereact/api"
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { get_emotions_from_sentiment, get_audio_history, get_audio_history_by_id, get_voice_interaction_sentiment, audio_extraction, voice_interaction_sentiment, get_all_black_listed_word } from 'services/voiceInteractionService';
import { useDispatch } from 'react-redux';
import { handleLoader } from 'redux/counterSlice';
import { toast } from 'react-toastify';
import { Dropdown } from 'primereact/dropdown';
import { Sidebar } from 'primereact/sidebar';
import { Calendar } from 'primereact/calendar';
import { formateDate } from "utils/formatDate";
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import VoiceInteraction from '../voice-interaction/VoiceInteraction';
const moment = require('moment');

const VoiceUpload = () => {
    // const navigate = useNavigate();
    const dispatch = useDispatch();
    const dropdownRef : any = useRef(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [selectedProducts, setSelectedProducts] =
        useState<Record<string, any>>()
    const [filters, setFilters] = useState<{ [s: string]: any }>();
    const [audioFiles, setAudioFiles] = useState([]);
    const [visibleRight, setVisibleRight] = useState(false);
    const [searchShow, setSearchShow] = useState(false);
    const [is_collapse, setIs_collapse] = useState("");
    const [selectedEmotion, setSelectedEmotion] = useState("All");
    const [selectedCSellUsell, setSelectedCSellUsell] = useState("All");
    const [selectedBlackListed, setSelectedBlackListed] = useState("All");
    const [audioExtract, setAudioExtract] = useState<any>("");
    const [audioSentiment, setAudioSentiment] = useState<any>({});
    const [emotions, setEmotions] = useState<any>([]);
    const [first, setFirst] = useState(0); // State to control the first page
    const [sortField, setSortField] = useState(""); // State to control the first page
    const [sortOrder, setSortOrder] = useState<any>(""); // State to control the first page
    const [rowsPerPage, setRowsPerPage] = useState(5); // State to control the rows per page
    const [blackListedWords, setBlackListedWords] = useState<any>([]);
    const [dates, setDates] = useState<any>([new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()]);
    const fileInputRef: any = useRef(null);
    const BlackListedWords = ["All", "Yes", "No"]
    const CrosssellUpsell = ["All", "Yes", "No"]
    const handleButtonClick = () => {
        // Trigger the file input when the button is clicked
        fileInputRef.current.click();
    };



    useEffect(() => {
        const sidebar = document.getElementById('wrapper'); 
    
        const handleSidebarHover = () => {
          if (sidebar && sidebar.classList.contains('sidebar--open')) { 
            // Close the dropdown
            dropdownRef.current?.hide(); 
          }
        };
    
       sidebar && sidebar.addEventListener('mouseover', handleSidebarHover);
    
        return () => {
          sidebar && sidebar.removeEventListener('mouseover', handleSidebarHover);
        };
      }, []);
    

    const getEmotions = async () => {
        try {
            const { result, error } = await get_emotions_from_sentiment();
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            const temp = result.map((i: string) => i.charAt(0).toUpperCase() + i?.slice(1));
            temp.unshift("All")
            setEmotions(temp);
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    const getHistory = async (data: string) => {
        dispatch(handleLoader(true));
        const from_date = formateDate(dates[0])
        const to_date = formateDate(dates[1])
        const tempEmo = selectedEmotion === "All" ? "" : selectedEmotion.toLowerCase()
        const tempBlak = selectedBlackListed === "All" ? "" : selectedBlackListed.toLowerCase();
        const tempSell = selectedCSellUsell === "All" ? "" : selectedCSellUsell.toLowerCase();
        try {

            const { result, error } = await get_audio_history(from_date, to_date, tempEmo, tempBlak, tempSell);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            setAudioFiles(result);
            // Reset the first page to 0 when filter is applied
            setFirst(0);
            if (data === "post") {
                setVisibleRight(true);
                setSelectedProducts(result[0])
            }
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    const postSentiment = async (body: any) => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await voice_interaction_sentiment(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            // dispatch(handleLoader(false));
            setAudioSentiment(result)
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    const getSentiment = async (id: string) => {

        try {
            const { result, error } = await get_voice_interaction_sentiment(id);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            // dispatch(handleLoader(false));
            setAudioSentiment(result)
        } catch (error: any) {
            // dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    const getAudioExtraction = async (id: string) => {
        try {
            const { result, error } = await get_audio_history_by_id(id);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            // dispatch(handleLoader(false));
            setAudioExtract(result);
        } catch (error: any) {
            // dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    const getBlacklistedWords = async () => {
        try {
            const { result, error } = await get_all_black_listed_word()
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result?.error
            }
            // dispatch(handleLoader(false));
            setBlackListedWords(result)
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Reset the first page to 0 when filter is applied
        setFirst(0);
        const value = e?.target?.value;
        let _filters = { ...filters };

        _filters['global']!.value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        })
        setGlobalFilterValue("")
    }

    useEffect(() => {
        getEmotions();
        initFilters();
        // CustomerService.getCustomersMedium().then((data) => setNotifications(data));
    }, []);
    useEffect(() => {
        if (dates[1] !== null) {
            getHistory("get");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dates, selectedEmotion, selectedBlackListed, selectedCSellUsell]);

    const handleClick = async (id: any) => {
        const temp: any = document?.getElementById("vocie")
        temp?.add("modal-open-vocie");
        // setLoader(true)
        dispatch(handleLoader(true));
        setSelectedProducts(id)
        // await getSentiment(id.audio_id);
        // await getAudioExtraction(id.audio_id);
        await getBlacklistedWords();
        setVisibleRight(true);
        dispatch(handleLoader(false));
    }
    const onCancel = () => {
        setVisibleRight(false);
        setAudioExtract("");
        setSelectedProducts({})
        setAudioSentiment({})
        const temp: any = document?.getElementById("vocie")
        temp?.remove("modal-open-vocie");
    }



    const capitalizeFirstLetter = (word: string) => {
        if (word === "joy") {
            return (<span className="p-2 joy text-xs fw-medium">
                Joy
            </span>)

        } else if (word === "sadness") {
            return <span className="p-2 sad text-xs fw-medium">
                Sadness
            </span>

        } else if (word === "anger") {
            return <span className="p-2 anger text-xs fw-medium">
                Anger
            </span>

        } else if (word === "fear") {
            return <span className="p-2 fear text-xs fw-medium">
                Fear
            </span>

        } else if (word === "love") {
            return <span className="p-2 love text-xs fw-medium">
                Love
            </span>

        } else if (word === "neutral") {
            return <span className="p-2 surprise text-xs fw-medium">
                Neutral
            </span>

        }
    };

    const handleDateSelection = (e: any) => {
        const selectedDatesArray = e.value;
        if (selectedDatesArray.length === 2) {
            // Update the selected dates when a valid range is selected
            setDates(selectedDatesArray);
        } else {
            // Clear the selection when less than two dates are selected
            setDates([]);
        }
    };

    const clearSearch = () => {
        setSearchShow(false)
        let _filters = { ...filters };
        _filters['global']!.value = "";
        setFilters(_filters);
        setGlobalFilterValue("");
    }

    const manipulateBase64Data = async (base64Data: string) => {
        return new Promise((resolve, reject) => {
            const base64Index = base64Data.indexOf('base64');
            if (base64Index !== -1) {
                resolve(base64Data?.slice(base64Index + 7));
            } else {
                resolve(base64Data);
            }
        });
    };

    const getBase64 = (file: any) => {
        return new Promise(async (resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.onload = async () => {
                const base64Data: any = fileReader.result;
                try {
                    const modifiedBase64Data = await manipulateBase64Data(base64Data);
                    resolve(modifiedBase64Data);
                } catch (error) {
                    reject(error);
                }
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
            fileReader.readAsDataURL(file);
        });
    };

    // File change
    const audioTypes = ["audio/ogg", "audio/mpeg", "audio/wav", "audio/mp3", "audio/vnd.dlna.adts"]
    const fileExtChange = (file: any) => {
        if (file.type === "audio/mpeg") {
            return file.name.replace('.mp3', '.txt')
        } else if (file.type === "audio/wav") {
            return file.name.replace('.wav', '.txt')
        } else if (file.type === "audio/vnd.dlna.adts") {
            return file.name.replace('.aac', '.txt')
        } else if (file.type === "audio/ogg") {
            return file.name.replace('.ogg', '.txt')
        }
    }
    const handleFileChange = async (event: any) => {
        const file = event.target.files[0];
        const size = Number(event?.target?.files[0].size / 1048576);
        if (size < 5 && file.size > 0) {
            if (file && audioTypes.includes(file.type)) {
                dispatch(handleLoader(true));
                const base64Data = await getBase64(file);
                const body: any = {};
                body.user_name = sessionStorage.getItem("username");
                body.file_data = base64Data;
                body.file_name = fileExtChange(file);
                body.audio_file_name = file.name;
                try {
                    const { result, error } = await audio_extraction(body);
                    if (error) {
                        throw error
                    }
                    if (result?.error) {
                        throw result.error
                    }
                    setAudioExtract(result);
                    const data: any = {}
                    data.user_name = sessionStorage.getItem("username");
                    data.audio_id = result.audio_id;
                    data.file_name = result.file_name;
                    data.file_data = result.encoded_text_value;
                    data.audio_file_name = file.name;
                    await postSentiment(data);
                    await getHistory("post");
                } catch (error: any) {
                    dispatch(handleLoader(false));
                    toast.error(error, {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    });
                }
                // await setInputFile(objectURL);
                // await setModalOption(objectURL);

            } else {
                fileInputRef.current.value = null;
                toast.error("File is not supported", {
                    style: {
                        backgroundColor: '#F1F1F1', // Grey background
                    }
                })
            }
        } else {
            fileInputRef.current.value = null;
            toast.error("File size should not be more than 5 MB", {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const handleDescription = (rowData: any) => {
        if (rowData.Description_result.length > 0) {
            return is_collapse === rowData.audio_id ? <span>{rowData.Description_result}{" "}<span className='fw-bold c-pointer text-danger' onClick={() => setIs_collapse("")}>less</span></span> : <span>{rowData?.Description_result?.slice(0, 70).trim()}{rowData?.Description_result?.length > 70 ? "..." : " "}<span className='fw-bold c-pointer text-primary' onClick={() => setIs_collapse(rowData.audio_id)}>more</span></span>
        }
    }

    const handleSort = (event: any) => {
        setSortField(event.sortField)
        setSortOrder(event.sortOrder)
        setFirst(0); // Move to page 1
    };
    const handleModal = () => {
        const temp = document.getElementById("vocie");
        temp?.classList.add("modal-open-vocie");
    }

    useEffect(() => {
        if (visibleRight) {
            document.body?.classList.add("modal-open-vocie");
        } else if (!visibleRight && document.body?.classList?.contains("modal-open-vocie")) {
            document.body?.classList.remove("modal-open-vocie");
        }
    }, [visibleRight])
    return (
        <div className='p-4 content-wrapper w-100 ' id='voice'>
            <section className="switch-section user-management-section">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h4 className="mb-0">My Calls</h4>
                </div>
                <div className="card" style={{overflow : visibleRight === true ? "hidden" : "auto"}}>
                    <div className="card-body">
                        <div className='mb-2 ali mycalls-head'>
                            <div className="mycalls-head-left">
                                <div className='d-flex align-items-center p-1 ps-3 pe-2 rounded-1 mb-2 mb-sm-0' style={{ background: "rgba(1, 61, 185, 0.15)", width: "221px", justifyContent: "space-between" }}>
                                    <span className='text-sm' >Black Listed Word: </span>
                                    <Dropdown ref={dropdownRef} value={selectedBlackListed} style={{ background: "rgba(1, 61, 185, 0.009)", maxWidth: "65px", boxShadow: "none" }} onChange={(e) => setSelectedBlackListed(e.value)} options={BlackListedWords}
                                        placeholder="Select a BlackListed" className="ms-2 fw-bold text-sm" />
                                </div>
                                <div className='d-flex align-items-center p-1 ps-3 pe-2 ms-sm-2 rounded-1 mb-2 mb-sm-0' style={{ background: "rgba(1, 61, 185, 0.15)" }}>
                                    <span className='text-sm'>Crosssell/Upsell: </span>
                                    <Dropdown ref={dropdownRef} value={selectedCSellUsell} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }} onChange={(e) => setSelectedCSellUsell(e.value)} options={CrosssellUpsell}
                                        placeholder="Select an Emotion" className="w-75 ms-2 fw-bold className='text-sm'" />
                                </div>
                                <div className='d-flex align-items-center p-1 ps-3 pe-2 ms-sm-2 rounded-1' style={{ background: "rgba(1, 61, 185, 0.15)" }}>
                                    <span className='text-sm'>Emotion: </span>
                                    <Dropdown ref={dropdownRef} value={selectedEmotion} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }} onChange={(e) => setSelectedEmotion(e.value)
                                    } options={emotions}
                                        placeholder="Select an Emotion" className="w-75 ms-2 fw-bold className='text-sm'" />
                                </div>
                                <Calendar
                                    maxDate={new Date()}
                                    value={dates}
                                    onChange={handleDateSelection}
                                    selectionMode="range"
                                    showIcon
                                    readOnlyInput
                                    // className="me-2"
                                    hideOnRangeSelection
                                    className="custom-calendar-icon ps-2  text-sm"
                                />
                            </div>
                            <div className="d-sm-flex mycalls-head-right">
                                <span className="p-input-icon-left">
                                    {/* <span className="p-input-icon-left me-sm-2 mb-2 mb-sm-0"> */}
                                    {searchShow ?
                                        <>
                                            <i className="pi pi-search" style={{ cursor: "pointer" }} onClick={clearSearch} />
                                            <InputText style={{ height: "3rem" }} value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
                                        </> :
                                        <div className="card" style={{ cursor: "pointer" }} onClick={() => setSearchShow(true)}>
                                            <i className="pi pi-search p-1" />
                                        </div>
                                    }
                                </span>

                            </div>
                        </div>
                        <DataTable
                            selection={selectedProducts}
                            onSelectionChange={(e) => setSelectedProducts(e.value)}
                            paginator
                            first={first}
                            onPage={(e) => { setFirst(e.first); setRowsPerPage(e.rows) }}
                            // Update the first page when paginating
                            filters={filters}
                            globalFilterFields={["audio_filename", "Title_result", "is_black_list_word", "is_selling", "emotion", "Description_result"]}
                            rows={rowsPerPage}
                            scrollable={true}
                            rowsPerPageOptions={[5, 10, 25]}
                            stripedRows
                            sortField={sortField}
                            sortOrder={sortOrder}
                            sortMode="single"
                            onSort={handleSort}
                            value={audioFiles}
                            tableStyle={{}}
                            emptyMessage="No voice records found"
                        >
                            <Column
                                selectionMode="single"
                                headerStyle={{ width: "3rem" }}
                            ></Column>
                            {/* <Column field="file_name" header="Name" body={(rowData: any) => (rowData.file_name.replace('.txt', '.mp3'))} sortable /> */}
                            <Column style={{ width: '3%' }} field="audio_filename" header="Name" sortable={true} />
                            <Column style={{ width: '15%' }} field="Title_result" header="Title" sortable={true} />
                            <Column style={{ width: '20%' }} field="Description_result" header="Description" body={(rowData: any) => handleDescription(rowData)} sortable={true} />
                            <Column field="is_black_list_word" header="Black Listed Words Exist?" body={(rowData: any) => (rowData.is_black_list_word.charAt(0).toUpperCase() + rowData?.is_black_list_word?.slice(1))} sortable={true}></Column>
                            <Column field="is_selling" header="Crosssell/ Upsell Opportunities?" body={(rowData: any) => (rowData.is_selling.charAt(0).toUpperCase() + rowData?.is_selling?.slice(1))} sortable={true}></Column>
                            <Column field="emotion" header="Emotion" body={(rowData: any) => capitalizeFirstLetter(rowData?.emotion)} sortable={true} />
                            <Column field="created_at" header="Date & Time" body={(rowData: any) => (moment(rowData.created_at).format('MMM DD, YYYY HH:mm:ss'))} sortable={true}></Column>
                            <Column header="Action" body={(rowData) => (
                                <div className='d-flex'>
                                    <Button className='pi pi-eye'
                                        // onClick={() => navigate(`/voice/${rowData?.audio_id}`)}
                                        onClick={() => handleClick(rowData)}
                                    ></Button>
                                </div>)}></Column>
                        </DataTable>
                        <Sidebar visible={visibleRight} position="right" onHide={onCancel} className="w-75">
                            {/* <VoiceInteraction onCancel={onCancel} audioExtract={audioExtract} audioSentiment={audioSentiment} blackListedWords={blackListedWords} /> */}
                        </Sidebar>

                    </div>
                </div>
            </section>
        </div>
    )
}

export default VoiceUpload